<script setup>
import '~/assets/css/navigation-search.css';
const emit=defineEmits(['modal:remove']);
const root=ref(),search=ref();
let panel;
function select(item){emit('modal:remove');return navigateTo(item.isCategory?item.path:'/catalog/product-'+item.id);}
function all(){emit('modal:remove');return navigateTo('/catalog');}
function keydown(event){
 if(event.key==='Escape'){event.preventDefault();event.stopPropagation();emit('modal:remove');return;}
 if(event.key!=='Tab'||!panel)return;
 const focusable=[...panel.querySelectorAll('button,a[href],input,select,textarea,[tabindex]')].filter(e=>!e.disabled&&e.tabIndex>=0&&e.getClientRects().length);
 const first=focusable[0],last=focusable.at(-1);
 if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
 else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
}
onMounted(async()=>{panel=root.value?.closest('[role="dialog"]');panel?.addEventListener('keydown',keydown);await nextTick();search.value?.focus();});
onBeforeUnmount(()=>panel?.removeEventListener('keydown',keydown));
</script>
<template>
 <section ref="root" class="uo-catalog-search-dialog">
  <p>Введите название растения, сорта или культуры. Подсказки появятся от трёх символов.</p>
  <CatalogSearch ref="search" :hide-create="true" :include-categories="true" @selected="select"/>
  <button class="uo-btn uo-btn-secondary" type="button" @click="all">Весь каталог →</button>
 </section>
</template>
